import { render, staticRenderFns } from "./AddressFields.vue?vue&type=template&id=61b777d0&scoped=true"
import script from "./AddressFields.vue?vue&type=script&lang=js"
export * from "./AddressFields.vue?vue&type=script&lang=js"
import style0 from "./AddressFields.vue?vue&type=style&index=0&id=61b777d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b777d0",
  null
  
)

export default component.exports